import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigurationModel } from '../+state/common.models';
import { CommonState } from '../+state/common.reducer';
import { getConfiguration } from '../+state/common.selectors';

@Injectable()
export class Http401Interceptor implements HttpInterceptor {
  configuration$: Observable<ConfigurationModel>;
  configuration: ConfigurationModel;
  constructor(private store: Store<CommonState>) {
    this.configuration$ = this.store.select(getConfiguration);
    this.configuration$.subscribe((config) => {
      this.configuration = config;
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<unknown>) => {
          // eslint-disable-next-line no-empty
          if (event instanceof HttpResponse) {
          }
        },
        (err: unknown) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              window.location.href = `${this.configuration.apiUrl}/authentication/login?returnUrl=${window.location.href}`;
              console.log('redirect');
            }
          }
        }
      )
    );
  }
}
